import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useDebouncedState } from '@mantine/hooks';
import { toast } from 'react-toastify';
import { RECORDS_PER_PAGE } from '../../config';
import { useState } from 'react';
import { handleLock, LogoutCheck } from '../utils';
import { buildAxiosInstance } from '../axiosInstance';
import { useMsal } from '@azure/msal-react';

const fetchinvoicesList = async ( Args, dispatch, signal,instance) => {
	await handleLock(dispatch, 'last_doc_open',instance)
	try {
		const TOAST_ID = 'get_invoice_list'
		const axiosInstance = buildAxiosInstance(TOAST_ID)
		let config = {
			params: {...Args, limit: localStorage.getItem("page_count")},
			signal: signal,
		};
		const responseData = await axiosInstance.get('/invoice_list',config)
		return responseData
	} catch (error) {
		LogoutCheck(error, dispatch,instance)	
		
	};
};

export const useInvoiceslistPagewise = (Sort) => {
	let dispatch = useDispatch();
	const { instance } = useMsal();
	const [Args, setArgs] = useState({
		search: '',
		template: "All",
		...Sort
	});
	const hook = useQuery({
		queryKey: ['invoices_list', Args],
		queryFn: async ({ signal }) =>
			fetchinvoicesList(Args, dispatch, signal,instance),
		retry: false,
	});
	return {
		hook: hook,
		Args: Args,
		setArgs: setArgs,
	};
};


export const useDeleteInvoice = () => {
	const queryClient = useQueryClient() 
	let dispatch = useDispatch()
	const { instance } = useMsal();
	return useMutation({
		retry: false,
		mutationFn: async (body) => {
			try {
				const TOAST_ID = 'delete_invoice_entities'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.delete(`/delete_invoice_entities`,{data : JSON.stringify(body)});
				let message = responseData?.message
				message && toast.success(message, { toastId: TOAST_ID })
				return responseData

			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw error
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['invoices_list'] })
		  },
	});
};


const fetchClientList = async (Args, dispatch, signal,instance) => {

	try {
		const TOAST_ID = 'vendor_names_list'
		const axiosInstance = buildAxiosInstance(TOAST_ID)
		let config = {
			params: {...Args, limit: localStorage.getItem("page_count")},
			signal: signal,
		};
		const responseData = await axiosInstance.get('/vendor_names_list',config)
		return responseData
	} catch (error) {
		LogoutCheck(error, dispatch,instance)	
		
	};
};

export const useVendorNames = (client_id) => {
	let dispatch = useDispatch();
	const { instance } = useMsal();
	const [Args, setArgs] = useDebouncedState(
		{
			search: '',
			client_id: client_id,
			page:1
		},
		1000
	);
	const hook = useQuery({
		queryKey: ['vendor_names', Args],
		queryFn: async ({ signal }) => fetchClientList(Args, dispatch, signal,instance),
		retry: false,
	});
	return {
		hook: hook,
		Args: Args,
		setArgs: setArgs,
	};
};


export const useRemapInvoices = (setIsOpened) => {
	const queryClient = useQueryClient() 
	let dispatch = useDispatch()
	const { instance } = useMsal();
	return useMutation({
		retry: false,
		mutationFn: async (body) => {
			try {
				const TOAST_ID = 'remap_invoices'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.post(`/remap_invoices`, JSON.stringify(body));
				let message = responseData?.message
				message && toast.success(message, { toastId: TOAST_ID })
				return responseData

			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw error
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['invoices_list'] })
			setIsOpened(false)
		  },

	});
};


export const useCategoryNameById = (cat_id) => {
	let dispatch = useDispatch()
	return useQuery({
		retry: false,
		queryKey: ['cat_name', cat_id],
		queryFn: async ({signal}) => {
			try {
				const TOAST_ID = 'get_category_by_id'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				let config = {
					params: {id:cat_id},
					signal:signal
				};
				const responseData = await axiosInstance.get('/get_category_by_id',config)
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch)	
				
			};
		},
	});
};

export const useBulkMarkComplete = () => {
	const { instance } = useMsal();
	let dispatch = useDispatch();
	//const Data = useSelector(state => state.auth)
	return useMutation({
		retry: 1,
		mutationFn:async (body)=> {
			try {
				const TOAST_ID = 'mark_complete_bulk'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.put(`/mark_complete`, JSON.stringify(body));
				console.log(responseData);
				toast.success(responseData.message)
				return responseData
			} catch (error) {

				LogoutCheck(error, dispatch,instance)
			}
		}
	});
};
export const useBulkMarkDraft = () => {
	const { instance } = useMsal();
	let dispatch = useDispatch();
	//const Data = useSelector(state => state.auth)
	return useMutation({
		retry: 1,
		mutationFn:async (body)=> {
			try {
				const TOAST_ID = 'mark_reviewed_bulk'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.put(`/mark_reviewed`, JSON.stringify(body));
				console.log(responseData);
				toast.success(responseData.message)
				return responseData
			} catch (error) {

				LogoutCheck(error, dispatch,instance)
			}
		}
	});
};


export const useGetTemplates = (client_id, vendor_id, category_id) => {
	let dispatch = useDispatch()
	return useQuery({
		retry: false,
		queryKey: ['templates', client_id, vendor_id, category_id],
		queryFn: async ({signal}) => {
			try {
				const TOAST_ID = 'templates_list'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				let config = {
					params: {client_id, vendor_id, category_id},
					signal:signal
				};
				const responseData = await axiosInstance.get('/templates_list',config)
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch)	
				
			};
		},
	});
};

export const useReleaseDoc= () => {
	const queryClient = useQueryClient() 
	let dispatch = useDispatch()
	const { instance } = useMsal();
	return useMutation({
		retry: false,
		mutationFn: async (body) => {
			try {
				const TOAST_ID = 'release_doc'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.post(`/release_doc_from_job`,body);
				let message = responseData?.message
				message && toast.success(message, { toastId: TOAST_ID })
				return responseData

			} catch (error) {
				LogoutCheck(error, dispatch,instance)
				throw error
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['invoices_list'] })
		  },
	});
};

export const useChangeTemplate = () => {
	const queryClient = useQueryClient()
	let dispatch = useDispatch()
	const { instance } = useMsal();
	return useMutation({
		retry: false,
		mutationFn: async (body) => {
			try {
				const TOAST_ID = 'change_template'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.post(`/change_template`, JSON.stringify(body));
				let message = responseData?.message
				message && toast.success(message, { toastId: TOAST_ID })
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch, instance)
				throw error
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['invoices_list'] })
		},
	});
};

export const useChangeTemplateBulk = (setIsOpened) => {
	const queryClient = useQueryClient()
	let dispatch = useDispatch()
	const { instance } = useMsal();
	return useMutation({
		retry: false,
		mutationFn: async (body) => {
			try {
				const TOAST_ID = 'change_template_bulk'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				const responseData = await axiosInstance.post(`/change_template_bulk`, JSON.stringify(body));
				let message = responseData?.message
				message && toast.success(message, { toastId: TOAST_ID })
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch, instance)
				throw error
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['invoices_list'] })
			setIsOpened(false)
		},
	});
};

export const useInvoicePageImages = (file_id) => {
	let dispatch = useDispatch()
	return useQuery({
		retry: false,
		enabled: Boolean(file_id),
		queryKey: ['invoice_page_images', file_id],
		queryFn: async ({signal}) => {
			try {
				const TOAST_ID = 'invoice_page_images'
				const axiosInstance = buildAxiosInstance(TOAST_ID)
				let config = {
					params: {file_id},
					signal:signal
				};
				const responseData = await axiosInstance.get('/invoice_page_images',config)
				return responseData
			} catch (error) {
				LogoutCheck(error, dispatch)
				throw error
			};
		},
	});
};